import { TicketTypeKeys } from './ticket-selector-option.interface';

export type TicketRouteMap = Record<TicketTypeKeys, string>;
